import React, { useRef, useState, useEffect } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Api } from '../../../services/api';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { EstimatorTemplate } from '../../../services/Template/estimator-template';
import { Toast } from 'primereact/toast';
import { useParams } from 'react-router-dom';
import { InputNumber } from 'primereact/inputnumber';
import './Estimating.css';
import '../../Lidtracker/Leads/Leads.css';
import { FaCopy, FaPlus, FaTrash, FaFilePdf, FaSave } from 'react-icons/fa';
import { toPng } from 'html-to-image';
import jsPDF from 'jspdf';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from "primereact/inputtext";
import { Checkbox } from 'primereact/checkbox';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { classNames } from "primereact/utils";

const EditEstimating = ({ ProjectIdEdit }) => {
    const [isLoading, setIsLoading] = useState(true);
    var { editId } = useParams();
    const [financials, setFinancials] = useState([1, 2, 3, 4, 5, 6]);
    const [preConstructionShedule, setPreConstructionShedule] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]);

    const [projectBudget, setProjectBudget] = useState([1, 2, 3, 4, 5]);
    const [ActionItems, setActionItems] = useState([1]);
    const [Title, setTitle] = useState([1, 2, 3, 4, 5]);
    const [estimatorProjectName, setEstimatorProjectName] = useState('');
    const [contractAmount, setContractAmount] = useState('');
    const [isCopyBtnLoading, setIsCopyBtnLoading] = useState(false);
    const [isPdfBtnLoading, setIsPdfBtnLoading] = useState(false);
    const [internalJob, setInternalJob] = useState("N");

    const adjustTextareaHeight = (textarea) => {
        textarea.style.height = 'auto'; // Reset the height
        textarea.style.height = textarea.scrollHeight + 'px'; // Set the height to the scroll height
    };

    const expandAllTextareas = () => {
        elementRefs.forEach(ref => {
            if (ref.current) {
                const textareas = ref.current.querySelectorAll('textarea');
                textareas.forEach(adjustTextareaHeight);
            }
        });
    };

    const copyImageToClipboard = (blob) => {
        if (navigator.clipboard && navigator.clipboard.write) {
            navigator.clipboard.write([
                new ClipboardItem({
                    [blob.type]: blob
                })
            ]).then(() => {
                setIsCopyBtnLoading(false);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Image copied to clipboard' });
                console.log('Image copied to clipboard');
            }).catch((error) => {
                setIsCopyBtnLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error copying image to clipboard' });
                console.error('Error copying image to clipboard:', error);
            });
        } else {
            setIsCopyBtnLoading(false);
            console.error('Clipboard API not available');
        }
    };

    const elementRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        // Add more refs for additional elements as needed
    ];

    const takeScreenshotAndCopy = async () => {
        setIsCopyBtnLoading(true);
        console.log('Take screenshot and copy to clipboard');

        try {
            // Expand all textareas to fit their content
            expandAllTextareas();

            const canvasPromises = elementRefs.map(async (ref) => {
                if (ref.current) {
                    return await toPng(ref.current, {
                        cacheBust: true,
                        pixelRatio: 2,
                    });
                }
                return null;
            });

            const images = await Promise.all(canvasPromises);

            // Create a new canvas to combine screenshots
            const combinedCanvas = document.createElement('canvas');
            const context = combinedCanvas.getContext('2d');

            // Calculate total height of combined screenshots
            let totalHeight = 0;
            let maxWidth = 0;
            for (const imgSrc of images) {
                if (!imgSrc) continue; 
                const img = new Image();
                img.src = imgSrc;
                await new Promise((resolve) => {
                    img.onload = () => {
                        totalHeight += img.height;
                        if (img.width > maxWidth) maxWidth = img.width;
                        resolve();
                    };
                    img.onerror = () => {
                        resolve();
                    }
                });
            }

            combinedCanvas.width = maxWidth;
            combinedCanvas.height = totalHeight;

            let offsetY = 0;
            for (const imgSrc of images) {
                 if (!imgSrc) continue; 
                const img = new Image();
                img.src = imgSrc;
                await new Promise((resolve) => {
                    img.onload = () => {
                        context.drawImage(img, 0, offsetY);
                        offsetY += img.height;
                        resolve();
                    };
                    img.onerror = () => {
                         resolve();
                    }
                });
            }

            // Convert the combined canvas to a data URL
            combinedCanvas.toBlob(blob => {
                if (blob) {
                    copyImageToClipboard(blob);
                } else {
                    console.error('Error creating blob');
                    setIsCopyBtnLoading(false);
                     if (toast.current) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to create image blob' });
                      }
                }
            }, 'image/png');

        } catch (error) {
            setIsCopyBtnLoading(false);
            console.error('Error taking screenshots:', error);
        }
    };

    const downloadPDF = async () => {
        setIsPdfBtnLoading(true);
        console.log('Download PDF');

        try {
            // Expand all textareas to fit their content
            expandAllTextareas();

            const canvasPromises = elementRefs.map(async (ref) => {
                if (ref.current) {
                    return await toPng(ref.current, {
                        cacheBust: true,
                        pixelRatio: 1.5, // Reduced from 2 to 1.5
                        backgroundColor: '#ffffff'
                    });
                }
                return null;
            });

            const images = await Promise.all(canvasPromises);

            // Create a new canvas to combine screenshots
            const combinedCanvas = document.createElement('canvas');
            const context = combinedCanvas.getContext('2d');

            // Calculate total height and max width of combined screenshots
            let totalHeight = 0;
            let maxWidth = 0;
            for (const imgSrc of images) {
                if (!imgSrc) continue; 
                const img = new Image();
                img.src = imgSrc;
                await new Promise((resolve) => {
                    img.onload = () => {
                        totalHeight += img.height;
                        if (img.width > maxWidth) maxWidth = img.width;
                        resolve();
                    };
                });
            }

            combinedCanvas.width = maxWidth;
            combinedCanvas.height = totalHeight;

            // Fill white background
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height);

            let offsetY = 0;
            for (const imgSrc of images) {
                if (!imgSrc) continue;
                const img = new Image();
                img.src = imgSrc;
                await new Promise((resolve) => {
                    img.onload = () => {
                        context.drawImage(img, 0, offsetY);
                        offsetY += img.height;
                        resolve();
                    };
                });
            }

            // Create PDF
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();   // 210mm
            const pdfHeight = pdf.internal.pageSize.getHeight(); // 297mm
            
            const totalCanvasWidth = combinedCanvas.width;
            const totalCanvasHeight = combinedCanvas.height;

            // Calculate how much canvas height fits on one PDF page
            const pageCanvasHeight = (pdfHeight * totalCanvasWidth) / pdfWidth; 

            let heightLeft = totalCanvasHeight;
            let currentY = 0;
            let pageIndex = 0;

            while (heightLeft > 0) {
                if (pageIndex > 0) {
                    pdf.addPage();
                }

                // Determine height of the slice for this page
                const sliceHeight = Math.min(heightLeft, pageCanvasHeight);

                // Create a temporary canvas for the slice
                const pageCanvas = document.createElement('canvas');
                pageCanvas.width = totalCanvasWidth;
                pageCanvas.height = sliceHeight;
                
                const pageCtx = pageCanvas.getContext('2d');
                
                // Fill white background
                pageCtx.fillStyle = '#ffffff';
                pageCtx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

                // Draw the specific slice from the combined canvas
                pageCtx.drawImage(
                    combinedCanvas, 
                    0, currentY, totalCanvasWidth, sliceHeight, // Source rectangle
                    0, 0, totalCanvasWidth, sliceHeight         // Destination rectangle
                );

                // Convert slice to JPEG (0.75 quality)
                const pageData = pageCanvas.toDataURL('image/jpeg', 0.75);

                // Calculate the height in PDF units for this slice
                const pdfSliceHeight = (sliceHeight * pdfWidth) / totalCanvasWidth;

                pdf.addImage(pageData, 'JPEG', 0, 0, pdfWidth, pdfSliceHeight);

                heightLeft -= sliceHeight;
                currentY += sliceHeight;
                pageIndex++;
            }
            
            const now = new Date();
            const options = {
                timeZone: 'America/Los_Angeles',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            };

            const formatter = new Intl.DateTimeFormat('en-US', options);
            const parts = formatter.formatToParts(now);
            const partValues = {};
            parts.forEach(p => partValues[p.type] = p.value);

            const timestamp = `${partValues.year}-${partValues.month}-${partValues.day}_${partValues.hour}-${partValues.minute}`;

            pdf.save(`Pre Construction Manager Playbook - Weekly Update - ${timestamp}.pdf`);

        } catch (error) {
            console.error('Error generating PDF:', error);
            if (toast.current) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF' });
            }
        } finally {
            setIsPdfBtnLoading(false);
        }
    };

    const handleAddInputForFinancials = () => {
        var t = EstimatorTemplate.getFormName().section_2[0];
        t.Financials = '';
        setFinancials([...financials, t]);
        formik.values.section_2.push(t);
    };

    const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);

    useEffect(() => {


        getTemplateDetails(ProjectIdEdit);

        return () => {
            //   formik.handleSubmit();
        };
    }, []);

    const getTemplateDetails = (id) => {

        var url = Api.API_BASE_URL + 'pre-con/get';
        formik.setFieldValue(`projectId`, id);

        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({ projectId: id }),

        })
            .then((response) => response.json())
            .then((response) => {
                if (response.error === '') {
                    editId = response.Estimator;
                    formik.setFieldValue('EstimatorId', response.Estimator);
                    setEstimatorProjectName(response.EstimatorProjectName);

                    formik.setFieldValue('contractAmount', response.contractAmount);
                    if (response.sec_2.length > 0) {
                        formik.setFieldValue(`section_2`, response.sec_2);
                        setFinancials(response.sec_2);
                    }
                    if (response.sec_4.length > 0) {
                        formik.setFieldValue(`section_4`, response.sec_4);
                        setPreConstructionShedule(response.sec_4);

                        console.log("formik.values.section_4---->", formik.values.section_4)
                    }
                    // if (response.sec_5.length > 0) {
                    //     formik.setFieldValue(`section_5`, response.sec_5);
                    //     setProjectBudget(response.sec_5);
                    // }
                    if (response.sec_5.length > 0) {
                        const updatedSection5 = response.sec_5.map(item => ({
                            ...item,
                            Amount: item.Amount === null ? "" : item.Amount // Set to empty string if null
                        }));

                        formik.setFieldValue(`section_5`, updatedSection5);
                        setProjectBudget(updatedSection5);
                    }
                    if (response.sec_6.length > 0) {
                        formik.setFieldValue(`section_6`, response.sec_6);
                        setActionItems(response.sec_6);
                    }
                    if (response.sec_7.length > 0) {
                        formik.setFieldValue(`section_7`, response.sec_7);
                        setTitle(response.sec_7);
                    }
                    if (response.sec_1) {
                        formik.setFieldValue(`ConceptualEstimate`, response.sec_1.ConceptualEstimate);
                        formik.setFieldValue(`FSA`, response.sec_1.FSA);
                        formik.setFieldValue(`HardBid`, response.sec_1.HardBid);
                        formik.setFieldValue(`ChangeOrders`, response.sec_1.ChangeOrders);
                        formik.setFieldValue(`Selections`, response.sec_1.Selections);
                        formik.setFieldValue(`Total`, response.sec_1.Total);
                        formik.setFieldValue(`ProjectManager`, response.sec_1.ProjectManager);
                        formik.setFieldValue(`InteriorDesigner`, response.sec_1.InteriorDesigner);
                        formik.setFieldValue(`VPComments`, response.sec_1.VPComments);
                    }
                    formik.setFieldValue(`projectId`, response.sec_3.projectId);
                    formik.setFieldValue(`dear`, response.sec_3.dear);
                    formik.setFieldValue(`vpConstructionCommentsForAll`, response.sec_3.vpConstructionCommentsForAll);
                    formik.setFieldValue(`dearVPCComments`, response.sec_3.dearVPCComments);
                    formik.setFieldValue(`hereIsYourWeeklySummaryFrom`, response.sec_3.hereIsYourWeeklySummaryFrom);
                    formik.setFieldValue(`hereIsYourWeeklySummaryTo`, response.sec_3.hereIsYourWeeklySummaryTo);
                    formik.setFieldValue(`hereIsYourWeeklySummaryVPCComments`, response.sec_3.hereIsYourWeeklySummaryVPCComments);
                    formik.setFieldValue(`projectSummary`, response.sec_3.projectSummary);
                    formik.setFieldValue(`projectSummaryVPCComments`, response.sec_3.projectSummaryVPCComments);
                    formik.setFieldValue(`scheduleConstructionStartDate`, response.sec_3.scheduleConstructionStartDate);
                    formik.setFieldValue(`scheduleProjectCompletion`, response.sec_3.scheduleProjectCompletion);
                    formik.setFieldValue(`scheduleVPCComments`, response.sec_3.scheduleVPCComments);
                    formik.setFieldValue(`no_of_month`, response.sec_3.no_of_month);
                    formik.setFieldValue(`actual_start_month`, response.sec_3.actual_start_month);
                    setInternalJob(response.sec_3.transferred_to_construction);
                    formik.setFieldValue(`costPerSF`, response.sec_3.costPerSF);
                    formik.setFieldValue(`costPerSFAmount`, response.sec_3.costPerSFAmount);
                    formik.setFieldValue(`costPerSFComments`, response.sec_3.costPerSFComments);

                    // formik.setFieldValue(`totalSqFt`, response.sec_3.totalSqFt);
                    formik.setFieldValue(`totalSqFt`, response.sec_3.totalSqFt ?? 0);

                    if (response.sec_3 && response.sec_4.length === 0) {
                        console.log('Testing');
                        formik.setFieldValue(`section_4.0.PlannedCompletionDate`, response.sec_3.scheduleConstructionStartDate);
                        formik.setFieldValue(`section_4.0.ActualCompletionDate`, response.sec_3.scheduleConstructionStartDate);
                        formik.setFieldValue(`section_4.0.CurrentForecastCompletionDate`, response.sec_3.scheduleProjectCompletion);
                        formik.setFieldValue(`section_4.12.CurrentForecastCompletionDate`, response.sec_3.scheduleProjectCompletion);
                        formik.setFieldValue(`section_4.12.PlannedCompletionDate`, response.sec_3.scheduleProjectCompletion);
                    }
                    // Condition to check if totalSqFt has a value before performing the calculation
                    // if (response.sec_3.totalSqFt && response.contractAmount) {
                    //     formik.setFieldValue('costPerSFAmount', response.contractAmount / response.sec_3.totalSqFt);
                    // }
                    if (response.sec_3.totalSqFt && response.contractAmount) {
                        const totalSqFt = response.sec_3.totalSqFt ?? 0;
                        if (totalSqFt !== 0) {
                            formik.setFieldValue('costPerSFAmount', response.contractAmount / totalSqFt);
                        } else {
                            formik.setFieldValue('costPerSFAmount', 0); // or some other default value
                        }
                    }

                } else {
                    formik.setFieldValue('EstimatorId', 0);
                    setInternalJob('N');
                    setEstimatorProjectName(response.EstimatorProjectName);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error:", error);
                setIsLoading(false);
            });
    };



    const handleDeleteInputForFinancials = (index) => {
        setFinancials([...financials, EstimatorTemplate.getFormName().section_2[0]]);
        var newArray = [...financials];
        newArray.splice(index, 1);
        formik.values.section_2.splice(index, 1);
        setFinancials(newArray);
    };

    const handleAddInputForPreConstructionShedule = () => {
        var t = EstimatorTemplate.getFormName().section_4[0];
        t.preConstructionShedule = '';
        t.Description = '';
        setPreConstructionShedule([...preConstructionShedule, t]);
        formik.values.section_4.push(t);
    };

    const handleDeleteInputForPreConstructionShedule = (index) => {
        setPreConstructionShedule([...preConstructionShedule, 2]);
        var newArray = [...preConstructionShedule];
        newArray.splice(index, 1);
        formik.values.section_4.splice(index, 1);
        setPreConstructionShedule(newArray);
    };

    const handleAddInputForProjectBudget = () => {
        var y = EstimatorTemplate.getFormName().section_5[0];
        y.ProjectBudget = 'tese';
        y.Description = '';
        y.Amount = '';
        const newProjectBudgetEntry = {
            ProjectBudget: "",
            Amount: "",
            PreConstManagerComments: "",
            VPComments: "",
        };
        if (formik) {
            formik.values.section_5 = [
                ...formik.values.section_5.slice(0, 1),
                newProjectBudgetEntry,
                ...formik.values.section_5.slice(1),
            ];
        }
        setProjectBudget([
            ...projectBudget.slice(0, 1),
            newProjectBudgetEntry,
            ...projectBudget.slice(1),
        ]);
        console.log("projectBudget", formik.values.section_5);
    };

    const handleDeleteInputForProjectBudget = (index) => {
        setProjectBudget([...projectBudget, EstimatorTemplate.getFormName().section_5[0]]);
        var newArray = [...projectBudget];
        newArray.splice(index, 1);
        formik.values.section_5.splice(index, 1);
        setProjectBudget(newArray);
    };

    const handleAddInputForActionItems = () => {
        setActionItems([...ActionItems, EstimatorTemplate.getFormName().section_6[0]]);
        formik.values.section_6.push(EstimatorTemplate.getFormName().section_6[0]);
    };

    const handleDeleteInputForActionItems = (index) => {
        setActionItems([...ActionItems, EstimatorTemplate.getFormName().section_6[0]]);
        var newArray = [...ActionItems];
        newArray.splice(index, 1);
        formik.values.section_6.splice(index, 1);
        setActionItems(newArray);
    };

    const handleAddInputForTitle = () => {
        var z = EstimatorTemplate.getFormName().section_7[0];
        z.Title = '';
        z.Description = '';
        setTitle([...Title, z]);
        formik.values.section_7.push(z);
    };

    const handleDeleteInputForTitle = (index) => {
        setTitle([...Title, EstimatorTemplate.getFormName().section_7[0]]);
        var newArray = [...Title];
        newArray.splice(index, 1);
        formik.values.section_7.splice(index, 1);
        setTitle(newArray);
    };

    const headerStyle = {
        background: "#FEC025",
        border: "1px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
    };

    const cellStyle = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        paddingTop: '5px'
    };

    const borderStyle = {};

    const yesCellStyle = {
        ...cellStyle,
    };

    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };

    const priceBodyTemplatee = (rowData) => {
        if (rowData === '' || rowData === null) {
            return '';
        }
        let numberValue = Number(rowData);
        if (isNaN(numberValue)) {
            return '';
        }
        const isNegative = rowData < 0; // Check if the value is negative
        return <span style={{ color: isNegative ? "red" : "black" }}>
            {formatCurrency(rowData)}
        </span>
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    //* ------------------
    const renderTextArea = (fieldName, placeholder, formData = '', rowCount = 2, disabled = false) => (
        <InputTextarea
            placeholder={placeholder}
            name={fieldName}
            autoResize
            rows={rowCount}
            id={fieldName}
            className="w-full text-center p-2 mb-0"
            value={formData !== '' ? formData : formik.values[fieldName]}
            disabled={disabled}
            onChange={(e) => {
                console.log(e.target.value)
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value);
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
        />
    );

    const renderTextAreaFull = (fieldName, placeholder, formData = '', rowCount = 2) => (
        <InputTextarea
            placeholder={placeholder}
            name={fieldName}
            autoResize
            rows={rowCount}
            id={fieldName}
            className="w-full text-center p-2 mb-0"
            value={formData !== '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                console.log(e.target.value)
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value);
            }}
            style={{
                width: '100%',
                height: "40px",
                boxSizing: 'border-box',
                border: 'none',
                outline: 'none',

                color: '#495057',
                display: 'flex',
                alignItems: 'center',
                // padding: '8px 5px',
                paddingTop: '8px',
                paddingLeft: '5px'
            }}
        />
    );

    const renderTextAreaFullDes = (fieldName, placeholder, formData = '', rowCount = 2) => {
        const role_id = parseInt(localStorage.getItem('role_id'), 10);
        const isEditable = [1, 2, 12, 13].includes(role_id);

        return (
            <InputTextarea
                placeholder={placeholder}
                name={fieldName}
                autoResize
                rows={rowCount}
                id={fieldName}
                className="w-full text-center p-2 mb-0"
                value={formData !== '' ? formData : formik.values[fieldName]}
                disabled={!isEditable}
                onChange={(e) => {
                    console.log(e.target.value);
                    setExistPageWithoutSave(true);
                    formik.setFieldValue(fieldName, e.target.value);
                }}
                style={{
                    width: '100%',
                    boxSizing: 'border-box',
                    border: 'none',
                    outline: 'none',

                    color: '#495057',
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: '8px',
                    paddingLeft: '5px'
                }}
            />
        );
    };

    const renderInputArea = (fieldName, placeholder = '', type = 'text', formData = '') => {
        let value = formData !== '' ? formData : formik.values[fieldName];
        if (type == 'date') {

            if (formData != null) {
                let timestamp = new Date(formData);



                if (!isNaN(timestamp.getTime())) {
                    value = timestamp.toISOString().split('T')[0];
                }
            }
        }

        // Define the background color based on the field name
        let backgroundColor = '';
        if (fieldName === 'section_4.0.PlannedCompletionDate') {
            backgroundColor = '#FFE1FF';
        } else if (fieldName === 'section_4.12.CurrentForecastCompletionDate') {
            backgroundColor = '#FFCFB3';
        } else if (fieldName === 'section_4.12.PlannedCompletionDate') {
            backgroundColor = '#FFEB55';
        } else if (fieldName === 'section_4.8.CurrentForecastCompletionDate') {
            backgroundColor = '#96CEB4';
        }


        return (
            <InputText
                type={type}
                placeholder={placeholder}
                name={fieldName}
                id={fieldName}
                className="w-full text-center p-2 mb-0"
                value={value}
                step="any"
                onChange={(e) => {
                    setExistPageWithoutSave(true);
                    formik.setFieldValue(fieldName, e.target.value);
                    if (fieldName === 'section_4.0.PlannedCompletionDate') {
                        formik.setFieldValue('scheduleConstructionStartDate', e.target.value);
                    }
                    if (fieldName === 'section_4.12.CurrentForecastCompletionDate') {
                        formik.setFieldValue('scheduleProjectCompletion', e.target.value);
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        // e.preventDefault();
                    }
                }}
                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center', marginTop: '0px', backgroundColor: backgroundColor }}
            />
        )
    };

    const renderInputAreaNum = (fieldName, formData = '') => (
        <InputNumber

            className="text-center"
            inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
            value={formData !== '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.value);
            }}

            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                }
            }}
            style={{
                width: "100%",
                height: "40px",
                boxSizing: "border-box",
                border: "none",

                textAlign: "center !important",
                marginTop: "0px",
            }}
        />
    );

    const renderInputAreaForAmount = (fieldName, formData = '') => (
        <InputNumber
            inputId="currency-us"
            className="text-center"
            inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
            value={formData !== '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.value);
            }}
            mode="currency"
            currency="USD"
            locale="en-US"
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                }
            }}
            style={{
                width: "100%",
                height: "40px",
                boxSizing: "border-box",
                border: "none",

                textAlign: "center !important",
                marginTop: "0px",
            }}
        />
    );

    const renderSelect = (fieldName, formdata = '') => {
        var val = (formdata !== '') ? formdata : formik.values[fieldName];
        if (val === undefined) {
            val = 'N';
        }
        return (
            <select
                name={fieldName}
                id={fieldName}
                value={formdata !== '' ? formdata : formik.values[fieldName]}
                className={'select-text-color-' + val}
                onChange={(e) => {
                    setExistPageWithoutSave(true);
                    formik.setFieldValue(fieldName, e.target.value);
                }}
                style={{ width: '100%', textAlign: 'center', color: 'white', backgroundColor: '#ff0000', border: 'none' }}
            >
                <option value="N">No</option>
                <option value="Y">Yes</option>
            </select>
        );
    };



    const renderSelectForCostPerSF = (fieldName) => (
        <select
            name={fieldName}
            id={fieldName}
            value={formik.values[fieldName]}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', textAlign: 'center', height: '45px', color: '#495057', border: '1px solid #DDDFE2', borderRight: 'none' }}>
            <option value="">Please choose an option</option>
            <option value="Custom Home with Basement">Custom Home with Basement</option>
            <option value="Custom Home Slab on Grade">Custom Home Slab on Grade</option>
            <option value="Custom Home Crawl">Custom Home Crawl</option>
            <option value="Town House">Town House</option>
            <option value="Condo Above Ground">Condo Above Ground</option>
            <option value="Condo 1 Level Underground">Condo 1 Level Underground</option>
            <option value="Addition">Addition</option>
            <option value="Whole home gut">Whole home gut</option>
            <option value="Tenent Improvement">Tenent Improvement</option>
            <option value="Commerical Build">Commerical Build</option>
            <option value="Renovation">Renovation</option>
        </select>
    );

    //! --------------

    const toast = useRef(null);

    const formik = useFormik({
        initialValues: EstimatorTemplate.getFormName(),
        validate: (data) => { },
        onSubmit: (data) => {

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            var url = Api.API_BASE_URL + 'pre-con/save';

            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    setExistPageWithoutSave(false);
                    if (Josn.error !== '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    });

    const BudgetRemaining = (index,) => {
        var value = formik.values.section_2[index].Budget - formik.values.section_2[index].AmountUsed;
        if (value === '' || value === null || value === undefined || value === 'NaN') {
            value = 0;
        }
        formik.values.section_2[index].BudgetRemaining = value;
        return (
            <span>{priceBodyTemplatee(formik.values.section_2[index].BudgetRemaining)}</span>
        );
    };

    const ProjectedBudgetToCompalte = (index,) => {
        var value = formik.values.section_2[index].EstimatedHoursToComplete * formik.values.section_2[index].ChargeOutRate;
        if (value === '' || value === null || value === undefined || value === 'NaN') {
            value = 0;
        }
        formik.values.section_2[index].ProjectedBudgetToComplete = value;
        return (
            <span>{priceBodyTemplatee(formik.values.section_2[index].ProjectedBudgetToComplete)}</span>
        );
    };

    const OverUnderBudget = (index,) => {
        var value = formik.values.section_2[index].BudgetRemaining - formik.values.section_2[index].ProjectedBudgetToComplete;
        if (value === '' || value === null || value === undefined || value === 'NaN') {
            value = 0;
        }
        formik.values.section_2[index].OverUnderBudget = value;
        return (
            <span>{priceBodyTemplatee(formik.values.section_2[index].OverUnderBudget)}</span>
        );
    };

    const calculateRemainingTotal = (index) => {
        var totalFsaBudget = 0;
        for (let i = 0; i < formik.values.section_5.length - 3; i++) {
            totalFsaBudget = totalFsaBudget + parseFloat(formik.values.section_5[i].Amount || 0);
        }
        if (index === formik.values.section_5.length - 3) {
            formik.values.section_5[formik.values.section_5.length - 3].Amount = totalFsaBudget;
            return totalFsaBudget;
        } else {
            var fsaRunningTotal = totalFsaBudget - (parseFloat(formik.values.section_5[formik.values.section_5.length - 2].Amount) || 0);
            fsaRunningTotal = isNaN(fsaRunningTotal) ? 0 : fsaRunningTotal;
            formik.values.section_5[formik.values.section_5.length - 1].Amount = fsaRunningTotal;
            return fsaRunningTotal;
        }
    };



    const deleteOrShowButtonShowInProjectBudget = (index, type) => {
        if (type === 'delete') {
            if (index === 0) {
                return false;
            }
        }
        if (formik.values.section_5[index].ProjectBudget === 'CWO total' || formik.values.section_5[index].ProjectBudget === 'Total FSA Budget' || formik.values.section_5[index].ProjectBudget === 'FSA Running Total' || formik.values.section_5[index].ProjectBudget === 'Total Cost Used') {
            return false;
        }
        return true;
    };

    const handleInternalJobChange = (isChecked) => {

        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(Api.API_BASE_URL + 'pre-con/transferred-to-construction', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                status: isChecked ? 'Y' : 'N',
                id: formik.values.EstimatorId
            }),
        })
            .then(response => response.json())
            .then(data => console.log(data))
            .catch(error => console.error(error));
    };



    const CostPerSFAmount = () => {
        if (formik.values.totalSqFt === '' || formik.values.totalSqFt === null || formik.values.totalSqFt === undefined || formik.values.totalSqFt === 'NaN' || formik.values.totalSqFt === 0) {
            return '';

        }


        const value = formik.values.contractAmount / formik.values.totalSqFt;
        const costPerSFAmount = (value === null || value === undefined || value.toString() === 'NaN' || value === '' || value === Infinity) ? 0 : value;

        formik.values.costPerSFAmount = costPerSFAmount;
        return (
            <span>{priceBodyTemplatee(costPerSFAmount)}</span>
        );
    };

    return (
        <div className="dashboard-container" style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Toast ref={toast} />
            {isLoading ? (
                <div className="loading-spinner">
                    Loading...
                    <div className="spinner"></div>
                </div>
            ) : (
                <form onSubmit={formik.handleSubmit} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                     <div className="dashboard-header fixed-header" style={{ flexShrink: 0 }}>
                        <div className="flex justify-content-between align-items-center w-full"> 
                             
                             <div className="flex align-items-center">
                                <h1 className="dashboard-title mr-4">Pre Construction Manager Playbook</h1>
                                
                                <div className='flex align-items-center ml-4' style={{ background: 'rgba(255,255,255,0.2)', padding: '5px 10px', borderRadius: '4px' }}>
                                    <label htmlFor="ingredient1" className="mr-2 text-white">PM Control</label>
                                    <Checkbox
                                        inputId="ingredient1"
                                        name="internal_job"
                                        value={internalJob}
                                        checked={internalJob === 'Y'}
                                        onChange={(e) => {
                                            console.log(e.target.checked);
                                            setInternalJob(e.target.checked ? 'Y' : 'N');
                                            handleInternalJobChange(e.target.checked);
                                        }}
                                    />
                                    <BsFillInfoCircleFill size={20} className='text-white ml-2' title='This is for the PM to control. If its a check, the date can be directly entered in the construction area. Otherwise, all the dates in the construction area are controlled from the pre-construction page.' />
                                </div>
                             </div>

                             <div className="header-actions">
                                <Button className="copySave-button" icon={<FaFilePdf />} label="Download PDF" loading={isPdfBtnLoading} type="button" onClick={downloadPDF} />
                                <Button className="copySave-button" icon={<FaCopy />} label="Copy Weekly Update" loading={isCopyBtnLoading} type="button" onClick={takeScreenshotAndCopy} />
                                <Button type="submit" className="customSave-button" icon={<FaSave />} label="SAVE" />
                             </div>
                        </div>
                    </div>
                    <div className="dashboard-card" style={{ flexGrow: 1, overflowY: 'auto', marginBottom: '20px', paddingBottom: '50px' }}>
                        <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5, 6]}>
                            <AccordionTab header="FINANCIALS" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}>Conceptual Estimate</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>FSA</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Hard Bid</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Change Orders</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Selections</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Total</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Project Manager</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Interior Designer</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Vp Construction Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th style={cellStyleW}>{renderInputArea(`ConceptualEstimate`, '', 'text')}</th>
                                                <th style={cellStyleW}>{renderInputArea(`FSA`, '', 'text')}</th>
                                                <th style={cellStyleW}>{renderInputArea(`HardBid`, '', 'number')}</th>
                                                <th style={cellStyleW}>{renderInputArea(`ChangeOrders`, '', 'number')}</th>
                                                <th style={cellStyleW}>{renderInputArea(`Selections`, '', 'number')}</th>
                                                <th style={cellStyleW}>{renderInputArea(`Total`, '', 'text')}</th>
                                                <th style={cellStyleW}>{renderInputArea(`ProjectManager`, '', 'text')}</th>
                                                <th style={cellStyleW}>{renderInputArea(`InteriorDesigner`, '', 'text')}</th>
                                                <th style={cellStyleW}>{renderTextAreaFull(`VPComments`, '',)}</th>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <table style={{ borderCollapse: "collapse", marginTop: '20px' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}>FINANCIALS</th>
                                                <th style={{ ...headerStyle, width: "100px" }}>Budget</th>
                                                <th style={{ ...headerStyle, width: "100px" }}>Amount Used</th>
                                                <th style={{ ...headerStyle, width: "80px" }}>Budget Remaining</th>
                                                <th style={{ ...headerStyle, width: "100px" }}>Estimated Hours to Complete</th>
                                                <th style={{ ...headerStyle, width: "100px" }}>Charge out Rate</th>
                                                <th style={{ ...headerStyle, width: "80px" }}>Projected Budget to Complete</th>
                                                <th style={{ ...headerStyle, width: "80px" }}>Over/Under Budget</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Comments</th>
                                                <th style={{ ...headerStyle, width: "80px" }}>Add Remove Rows</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {financials.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={cellStyleW}>{renderTextArea(`section_2.${index}.Financials`, '', formik.values.section_2[index].Financials)}</td>
                                                    <td style={cellStyleW}>{renderInputAreaForAmount(`section_2.${index}.Budget`, formik.values.section_2[index].Budget)}</td>
                                                    <td style={cellStyleW}>{renderInputAreaForAmount(`section_2.${index}.AmountUsed`, formik.values.section_2[index].AmountUsed)}</td>
                                                    <td style={{ ...cellStyle, textAlign: 'center' }}>{BudgetRemaining(index)}</td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_2.${index}.EstimatedHoursToComplete`, formik.values.section_2[index].EstimatedHoursToComplete)}</td>
                                                    <td style={cellStyleW}>{renderInputAreaForAmount(`section_2.${index}.ChargeOutRate`, formik.values.section_2[index].ChargeOutRate)}</td>
                                                    <td style={{ ...cellStyleW, textAlign: 'center' }}>{ProjectedBudgetToCompalte(index)}</td>
                                                    <td style={{ ...cellStyleW, textAlign: 'center' }}>{OverUnderBudget(index)}</td>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_2.${index}.VPComments`, '', formik.values.section_2[index].VPComments)}</td>
                                                    <td style={cellStyleW}>
                                                        {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForFinancials(index)} />) : null}
                                                        {financials.length - 1 === index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForFinancials()} />) : null}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <table style={{ borderCollapse: "collapse", marginTop: '20px' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Cost Per Sf</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            <tr>
                                                <td style={{ ...cellStyle, alignItems: 'center', padding: '10px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', flex: 1, flexDirection: 'column' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', flex: 1, width: '100%' }}>
                                                            <div style={{ width: '25%', marginRight: '15px' }}>
                                                                <div style={{ textAlign: 'center', marginBottom: '5px' }}>Dropdown</div>
                                                                {renderSelectForCostPerSF('costPerSF')}
                                                            </div>
                                                            <div style={{ width: '25%', marginRight: '15px' }}>
                                                                <div style={{ textAlign: 'center', marginBottom: '5px' }}>
                                                                    <label> Total Sq Ft </label>
                                                                    <BsFillInfoCircleFill size={14} className='text-gray-500 hover:text-gray-900' title='This is the total livable SF of the project, including the garage and any unfinished space.' />
                                                                </div>
                                                                {renderInputAreaNum('totalSqFt')}
                                                            </div>
                                                            <div style={{ width: '25%', marginRight: '15px' }}>
                                                                <div style={{ textAlign: 'center', marginBottom: '5px' }}>Cost Per Sf Amount</div>
                                                                <div className='bg-white text-center align-center' style={{ height: "40px", paddingTop: '8px', }}>

                                                                    {CostPerSFAmount()}
                                                                </div>
                                                            </div>

                                                            <div style={{ width: '25%', marginRight: '15px' }}>
                                                                <div style={{ textAlign: 'center', marginBottom: '5px' }}>Comments</div>
                                                                {renderTextAreaFull('costPerSFComments', 'comments')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="PROJECT ADDRESS" className="mt-2 mb-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>
                                    <table style={{ borderCollapse: "collapse" }}>

                                        <tbody>

                                            <tr>
                                                <td style={{ ...borderStyle, minWidth: '100%', display: 'flex', alignItems: 'center', paddingTop: '15px' }}>
                                                    <td style={{ width: '100px' }}>Dear</td>
                                                    {renderTextArea('dear', "", formik.values.dear)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                                                    Weekly Summary
                                                    <sup> <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='The date is updated automatically every week when it is archived.' /></sup> :
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...borderStyle, display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                    </div>

                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }}>From</div>

                                                        <input
                                                            type="date"
                                                            name='hereIsYourWeeklySummaryFrom'
                                                            value={formik.values.hereIsYourWeeklySummaryFrom == null ? formik.values.hereIsYourWeeklySummaryFrom : !isNaN(new Date(formik.values.hereIsYourWeeklySummaryFrom).getTime()) ? new Date(formik.values.hereIsYourWeeklySummaryFrom).toISOString().split('T')[0] : formik.values.hereIsYourWeeklySummaryFrom
                                                            }

                                                            onChange={(e) => {
                                                                setExistPageWithoutSave(true);
                                                                formik.setFieldValue('hereIsYourWeeklySummaryFrom', e.target.value);
                                                            }}
                                                            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center' }}
                                                        />
                                                    </div>

                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }}>To</div>

                                                        <input
                                                            type="date"
                                                            name='hereIsYourWeeklySummaryTo'
                                                            value={formik.values.hereIsYourWeeklySummaryTo == null ? formik.values.hereIsYourWeeklySummaryTo : !isNaN(new Date(formik.values.hereIsYourWeeklySummaryTo).getTime()) ? new Date(formik.values.hereIsYourWeeklySummaryTo).toISOString().split('T')[0] : formik.values.hereIsYourWeeklySummaryTo
                                                            }

                                                            onChange={(e) => {
                                                                setExistPageWithoutSave(true);
                                                                formik.setFieldValue('hereIsYourWeeklySummaryTo', e.target.value);
                                                            }}
                                                            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center' }}
                                                        />
                                                    </div>
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                                                    Project Summary:
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...borderStyle, display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                                    {renderTextAreaFull('projectSummary', "",)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                                                    Schedules :
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...borderStyle, display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }}>
                                                            FSA Start Date:
                                                            <sup>
                                                                <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='This date is Comming From: FSA signed - Planned Completion Date ' />
                                                            </sup>
                                                        </div>

                                                        <input
                                                            type="date"
                                                            name='scheduleConstructionStartDate'
                                                            value={formik.values.scheduleConstructionStartDate == null ? formik.values.scheduleConstructionStartDate : !isNaN(new Date(formik.values.scheduleConstructionStartDate).getTime()) ? new Date(formik.values.scheduleConstructionStartDate).toISOString().split('T')[0] : formik.values.scheduleConstructionStartDate
                                                            }
                                                            readOnly
                                                            onChange={(e) => {
                                                                setExistPageWithoutSave(true);
                                                                formik.setFieldValue('scheduleConstructionStartDate', e.target.value);
                                                            }}
                                                            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', background: "#FFE1FF", textAlign: 'center', }}
                                                        />
                                                    </div>

                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }}>
                                                            Building Permit Received Date:
                                                            <sup>
                                                                <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='This date is Comming From : Building Permit Received - Forecasted Completion Date ' />
                                                            </sup>
                                                        </div>

                                                        <input
                                                            type="date"
                                                            name='scheduleProjectCompletion'
                                                            value={formik.values.scheduleProjectCompletion == null ? formik.values.scheduleProjectCompletion : !isNaN(new Date(formik.values.scheduleProjectCompletion).getTime()) ? new Date(formik.values.scheduleProjectCompletion).toISOString().split('T')[0] : formik.values.scheduleProjectCompletion
                                                            }
                                                            onChange={(e) => {
                                                                setExistPageWithoutSave(true);
                                                                formik.setFieldValue('scheduleProjectCompletion', e.target.value);
                                                            }}
                                                            readOnly
                                                            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', background: "#FFCFB3", textAlign: 'center' }}
                                                        />
                                                    </div>

                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }} >
                                                            Delayed Construction:
                                                            <sup>
                                                                <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title=' Is the number of months the project will be delayed after the building permit is received if the project cannot start when the building permit is received. Leave 0 if planning to start shortly after the building permit is received.' />
                                                            </sup>
                                                        </div>
                                                        {renderInputArea('actual_start_month', '', 'number')}
                                                    </div>

                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }} >
                                                            Construction Months:
                                                            <sup>
                                                                <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title=' Is the estimated number of months the project will take to complete from start to finish.' />
                                                            </sup>
                                                        </div>
                                                        {renderInputArea('no_of_month', '', 'number')}
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="PRE CONSTRUCTION SCHEDULED MILESTONES" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[1]}>
                                    <table style={{ borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}>Pre Construction Scheduled Milestones</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Planned Completion Date</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Forecasted Completion Date</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Actual Completion Date</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Description of Expected Pre Construction timelines. Subject to change</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Notes: If applicable, explain why there was a change to the Pre Construction schedule</th>
                                                <th style={{ ...headerStyle, width: "80px" }}>Add Remove Rows</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {preConstructionShedule.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={cellStyleW}>{renderTextArea(`section_4.${index}.preConstructionShedule`, '', formik.values.section_4[index].preConstructionShedule)}</td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_4.${index}.PlannedCompletionDate`, '', 'date', formik.values.section_4[index].PlannedCompletionDate)}</td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_4.${index}.CurrentForecastCompletionDate`, '', 'date', formik.values.section_4[index].CurrentForecastCompletionDate)}</td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_4.${index}.ActualCompletionDate`, '', 'date', formik.values.section_4[index].ActualCompletionDate)}</td>
                                                    <td style={cellStyleW}>{renderTextAreaFullDes(`section_4.${index}.Description`, '', formik.values.section_4[index].Description)}</td>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_4.${index}.Notes`, '', formik.values.section_4[index].Notes)}</td>
                                                    <td style={cellStyleW}>
                                                        {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForPreConstructionShedule(index)} />) : null}
                                                        {preConstructionShedule.length - 1 === index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForPreConstructionShedule()} />) : null}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="PROJECT BUDGET" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[2]}>
                                    <table style={{ borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}>Project Budget</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Amount</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Pre Construction Manager Comments</th>
                                                <th style={{ ...headerStyle, width: "80px", textAlign: 'center' }}>Add Remove Rows</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {projectBudget.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={cellStyleW}>
                                                        {renderTextArea(`section_5.${index}.ProjectBudget`, '', formik.values.section_5[index].ProjectBudget, 2, !deleteOrShowButtonShowInProjectBudget(index, 'text'))}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {index === formik.values.section_5.length - 1 || index === formik.values.section_5.length - 3 ? (
                                                            <InputNumber
                                                                inputId="currency-us"
                                                                className="text-center"
                                                                inputClassName={calculateRemainingTotal(index) < 0 ? "is-negative" : "is-positive"}
                                                                placeholder=""
                                                                value={calculateRemainingTotal(index)}
                                                                mode="currency"
                                                                currency="USD"
                                                                locale="en-US"

                                                                style={{
                                                                    width: "100%",
                                                                    height: "40px",
                                                                    boxSizing: "border-box",
                                                                    border: "none",
                                                                    textAlign: "center !important",
                                                                    marginTop: "0px",
                                                                }}
                                                            />
                                                        ) : (
                                                            renderInputAreaForAmount(`section_5.${index}.Amount`, formik.values.section_5[index].Amount)
                                                        )}
                                                    </td>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_5.${index}.PreConstManagerComments`, '', formik.values.section_5[index].PreConstManagerComments)}</td>
                                                    <td style={cellStyleW}>
                                                        {deleteOrShowButtonShowInProjectBudget(index, 'delete') ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForProjectBudget(index)} />) : null}
                                                        {index === 0 ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForProjectBudget()} />) : null}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="ACTION ITEMS" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[3]}>
                                    <table style={{ borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "auto" }}>Action Items</th>
                                                <th style={{ ...headerStyle, width: "80px", textAlign: 'center' }}>Add Remove Rows</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ActionItems.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_6.${index}.ActionItems`, '', formik.values.section_6[index].ActionItems)}</td>
                                                    <td style={cellStyleW}>
                                                        {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForActionItems(index)} />) : null}
                                                        {ActionItems.length - 1 === index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForActionItems()} />) : null}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="PLANNED BASELINE" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}></th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Planned Baseline Completion Date</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Current Forecast Completion Date</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Actual Completion Date</th>
                                                <th style={{ ...headerStyle, width: "100px" }}>Done:Yes or No</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Pre Construction Manager Comments</th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>VP Ops Comments</th>
                                                <th style={{ ...headerStyle, width: "80px", textAlign: 'center' }}>Add Remove Rows</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Title.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_7.${index}.Title`, '', formik.values.section_7[index].Title)}</td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_7.${index}.PlannedCompletionDate`, '', 'date', formik.values.section_7[index].PlannedCompletionDate)}</td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_7.${index}.CurrentForecastCompletionDate`, '', 'date', formik.values.section_7[index].CurrentForecastCompletionDate)}</td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_7.${index}.ActualCompletionDate`, '', 'date', formik.values.section_7[index].ActualCompletionDate)}</td>
                                                    <td style={{ ...dropdownCellStyle, width: "100px", height: '32px' }}>{renderSelect(`section_7.${index}.Done`, formik.values.section_7[index].Done)}</td>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_7.${index}.PreConstManagerComments`, '', formik.values.section_7[index].PreConstManagerComments)}</td>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_7.${index}.VPComments`, '', formik.values.section_7[index].VPComments)}</td>
                                                    <td style={cellStyleW}>
                                                        {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForTitle(index)} />) : null}
                                                        {Title.length - 1 === index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForTitle()} />) : null}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="VP CONSTRUCTION OPS COMMENTS" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>Vp Construction Ops Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={cellStyleW}>{renderTextAreaFull(`vpConstructionCommentsForAll`, '', '', 6)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>
                        </Accordion>
                        <div style={{ height: '300px' }}></div>
                    </div>
                </form>
            )}
        </div>
    );
}

export default EditEstimating;